document.addEventListener('DOMContentLoaded', function () {

      $('.corals-grid').slick({
        dots: false,
        infinite: false,
        arrows: false,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              infinite: false,
              dots: false,
            },
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1.18,
              slidesToScroll: 1,
              arrows: true,
            },
          },
        ],
      });
    

      $('.help-guides-grid').slick({
        dots: false,
        infinite: false,
        arrows: false,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              infinite: false,
              dots: false,
            },
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1.1,
              slidesToScroll: 1,
              arrows: true,
            },
          },
        ],
      });

      function initHelpGuidesBlogSlider() {
        const $slider = $('.help-guides__grid');
        if ($(window).width() < 768) {
          $slider.each(function() {
            const $this = $(this);
            if (!$this.hasClass('slick-initialized')) {
              $this.slick({
                dots: false,
                infinite: false,
                arrows: true,
                speed: 300,
                slidesToShow: 1.1,
                slidesToScroll: 1,
              });
            }
          });
        } else {
          $slider.each(function() {
            const $this = $(this);
            if ($this.hasClass('slick-initialized')) {
              $this.slick('unslick');
            }
          });
        }
      }
      initHelpGuidesBlogSlider();
      $(window).on('resize', initHelpGuidesBlogSlider);
      $(document).on('shopify:section:load', function() {
        initHelpGuidesBlogSlider();
      });

      $('.carousel-cstm .featured-collection-slider__products').slick({
        dots: false,
        infinite: true,
        arrows: true,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              infinite: true,
              dots: false,
            },
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1.1,
              slidesToScroll: 1,
              arrows: true,
            },
          },
        ],
      });

      $('.review-slider').slick({
        centerMode: true,
        arrows: false,
        centerPadding: '60px',
        slidesToShow: 3,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              arrows: false,
              centerMode: true,
              centerPadding: '40px',
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 768,
            settings: {
              arrows: false,
              centerMode: true,
              centerPadding: '30px',
              slidesToShow: 1,
            },
          },
        ],
      });

      $('#additional-col').slick({
        arrows: false,
        slidesToShow: 7,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              arrows: false,
              slidesToShow: 4,
            },
          },
          {
            breakpoint: 480,
            settings: {
              arrows: false,
              slidesToShow: 2.1,
            },
          },
        ],
      });

      $('.youtube-grid').slick({
        dots: false,
        infinite: false,
        arrows: false,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              infinite: false,
              dots: false,
            },
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1.1,
              slidesToScroll: 1,
              arrows: true,
            },
          },
        ],
      });
    

      document.querySelectorAll('.category-item').forEach((item) => {
        item.addEventListener('mouseenter', () => {
          const index = item.dataset.index;

          document.querySelectorAll('.category-item').forEach((i) => i.classList.remove('active'));

          document.querySelectorAll('.mega-panel').forEach((p) => p.classList.remove('active'));

          item.classList.add('active');
          const panel = document.querySelector(`.mega-panel[data-index="${index}"]`);
          if (panel) panel.classList.add('active');
        });
      });
    

      $(document).ready(function () {
                const $toggle = $('.categories-toggle');
        const $dropdown = $('.categories-dropdown');
        const $body = $('body');

        let isOpen = false;

        function openMenu() {
          if (isOpen) return;

          document.dispatchEvent(new CustomEvent('closeServicesMenu'));

          $dropdown.stop(true, true).slideDown(200);
          $body.addClass('categories-open');
          $toggle.attr('aria-expanded', 'true');
          isOpen = true;
        }

        function closeMenu() {
          if (!isOpen) return;
          $dropdown.stop(true, true).slideUp(200);
          $body.removeClass('categories-open');
          $toggle.attr('aria-expanded', 'false');
          isOpen = false;
        }

        function toggleMenu() {
          if (isOpen) {
            closeMenu();
          } else {
            openMenu();
          }
        }

        
        $toggle.on('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          toggleMenu();
        });

        
        $(document).on('click', function (e) {
          if (!$(e.target).closest('.header-categories').length) {
            closeMenu();
          }
        });

        
        $(document).on('keydown', function (e) {
          if (e.key === 'Escape') {
            closeMenu();
          }
        });

        document.addEventListener('closeCategoriesMenu', function () {
          closeMenu();
        });

      });
    

      $(document).ready(function () {
        $(document).on('click', '.view-all-btn', function () {
          const $btn = $(this);
          const $list = $btn.prev('.grandchild-list');

          $list.find('.is-hidden').slideDown(200).removeClass('is-hidden');
          $btn.remove();
        });
      });
    

      (function () {
        document.querySelectorAll('.view-all-btn').forEach(function (btn) {
          btn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            const column = btn.closest('.mega-column');
            const hiddenItems = column.querySelectorAll('.is-hidden');

            hiddenItems.forEach(function (item) {
              item.classList.remove('is-hidden');
            });

            btn.style.display = 'none';
          });
        });
      })();
    

      (function () {
        var faqBtn = document.getElementById('faq-button');
        if (faqBtn) {
          faqBtn.addEventListener('click', function (event) {
            event.preventDefault();
            var faqSection = document.getElementById('faq-content');
            if (faqSection) {
              var offset = 100;
              var faqPosition = faqSection.getBoundingClientRect().top + window.scrollY - offset;
              window.scrollTo({ top: faqPosition, behavior: 'smooth' });
            }
          });
        }

        var tvBtn = document.getElementById('tv-button');
        if (tvBtn) {
          tvBtn.addEventListener('click', function (event) {
            event.preventDefault();
            var videoSection = document.getElementById('ss-video-with-text');
            if (videoSection) {
              videoSection.style.display = 'block';
              var offset = 100;
              var videoPosition = videoSection.getBoundingClientRect().top + window.scrollY - offset;
              window.scrollTo({ top: videoPosition, behavior: 'smooth' });
            }
          });
        }

        var readMoreBtn = document.querySelector('.read_more_btn');
        var readMoreContent = document.querySelector('.read_more_content');
        if (readMoreBtn && readMoreContent) {
          readMoreBtn.addEventListener('click', function() {
            readMoreContent.classList.toggle('active');
            if (readMoreContent.classList.contains('active')) {
              readMoreBtn.textContent = 'Read less...';
            } else {
              readMoreBtn.textContent = 'Read more...';
            }
          });
        }
      })();

      document.addEventListener('click', function(e) {
        const anchor = e.target.closest('a[href^="#"]');
        if (!anchor) return;
        const targetId = anchor.getAttribute('href');
        if (targetId && targetId !== '#') {
          const targetElement = document.querySelector(targetId);
          if (targetElement) {
            e.preventDefault();
            targetElement.scrollIntoView({ behavior: 'smooth' });
          }
        }
      });
    
});
